export default null;throw new Error("Unable to resolve \"./_stream_duplex\" from npm:pngjs@5.0.0/browser.js");